/**
 * Shared honeypot field config. The field is hidden from humans via CSS + aria
 * attributes. Bots that autofill every text input will populate it, which we
 * treat as a silent rejection (no error surfaced so the bot cannot adapt).
 */
export const HONEYPOT_FIELD_NAME = 'website'

export function isHoneypotFilled(value: unknown): boolean {
  return typeof value === 'string' && value.trim().length > 0
}
